import { createAction, props } from '@ngrx/store';

export const reRunUpdatePayments = createAction(
  '[ReRunUpdatePayment] Load ReRunUpdatePayments',
  props<{ businessId: string; businessPaymentRunId: string }>()
);

export const reRunUpdatePaymentsSuccess = createAction('[ReRunUpdatePayment] Load ReRunUpdatePayments Success', props<{ response: any }>());

export const reRunUpdatePaymentsFailure = createAction(
  '[ReRunUpdatePayment] Load ReRunUpdatePayments Failure',
  props<{ error: Error | any }>()
);
